// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportName.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {


  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Link = require('react-router').Link;
  var constants = require('logic/data/Izenda.ReportsConstants');
  var Config = require('config');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));
  var UiState = require('logic/Izenda.UiState');
  var ACCESS_RIGHT = require('logic/data/Izenda.AuthorizationConstants').ACCESS_RIGHT;

  var SearchCriteria = constants.SEARCH_CRITERIA;
  const { isNil, isEmpty, get } = require('lodash/fp');

  var ReportName = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
      dataDetail: React.PropTypes.object
    },

    getInitialState: function() {
      this.originalReportName = this.props.dataDetail.name;
      return { editMode: false };
    },

    componentWillReceiveProps: function(nextProps) {
      if (nextProps.dataDetail.name != this.props.dataDetail.name) {
        this.originalReportName = nextProps.dataDetail.name;
      }
    },

    /**
     * Handle enter
     * @param {Object} event
     */
    handleEnter: function(e) {
      if (e.key === 'Enter') {
        this.handleSaveReportName();
      }
    },

    /**
     * Handle save report name
     */
    handleSaveReportName: function(e) {
      this.props.dataDetail.setEditMode && this.props.dataDetail.setEditMode(true);

      // Stop event blur if current event is mouse down
      if (e && e.type === 'mousedown') {
        e.preventDefault();
        e.stopPropagation();
      }

      var props = this.props;
      var loader = props.loader;
      var dataDetail = this.props.dataDetail;
      var valManager = this.props.validation;
      var reportDesignerModel = props.fieldStore.masterModel;
      var reportGeneralData = reportDesignerModel.getGeneralData();

      if (dataDetail.name === this.originalReportName) {
        this.setState({ editMode: false });
        return;
      }

      reportGeneralData.name = dataDetail.name;
      valManager.validate('reportName').then(
        function(success) {
          if (success) {
            loader.startLoading();
            return props.store
              .validateName(reportGeneralData)
              .then(
                function(response) {
                  if (isNil(response)) {
                    this.props.dataDetail.setEditMode && this.props.dataDetail.setEditMode(false);
                    props.updateName && props.updateName(dataDetail.name);
                    this.originalReportName = props.dataDetail.name;
                    this.setState({ editMode: false });
                  } else {
                    ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
                  }
                  if (!isEmpty(response)) {
                    // Change error key to reportName
                    response.map(function(message) {
                      message.key = 'reportName';
                    });
                    valManager.updateErrors(response);
                  }
                }.bind(this)
              )
              .finally(loader.endLoading.bind(loader));
          }
        }.bind(this)
      );
    },

    /**
     * Handle cancel button
     */
    handleCancelRename: function() {
      this.setState({ editMode: false });
      this.props.dataDetail.name = this.originalReportName;
    },

    /**
     * Rename
     * @param {Object} event
     */
    handleRename: function(e) {
      this.setState({ editMode: true });
      e.preventDefault();
      e.stopPropagation();
    },

    /**
     * Change report name
     * @param {Object} input
     */
    onChangeReportName: function(input) {
      this.props.dataDetail.name = input.target.value;
      this.setState({ editMode: this.state.editMode });
    },

    /**
     * Render report name component with edit mode
     * @return {Object} component
     */
    renderEditReportName: function() {
      var localization = this.props.localization;
      var dataDetail = this.props.dataDetail;

      return (
        <div className="title-edit form-group">
          <div className="input-group">
            <Input
              ref="inputName"
              value={dataDetail.name}
              onChange={this.onChangeReportName}
              onKeyPress={this.handleEnter}
              onBlur={this.handleSaveReportName}
              field="reportName"
              validations={constants.CONSTRAINTS.NAME}
              className="form-control"
              autoFocus
            />
            <span className="input-group-btn">
              <button
                className="btn btn-default"
                onMouseDown={this.handleSaveReportName}
                title={localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')}
              >
                <span className="icon-ok success-color" />
              </button>
              <button
                className="btn btn-default"
                onMouseDown={this.handleCancelRename}
                title={localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')}
              >
                <span className="icon-cancel" />
              </button>
            </span>
          </div>
        </div>
      );
    },

    /**
     * Render report name component with view mode
     * @return {Object} component
     */
    renderViewReportName: function() {
      var props = this.props;
      var localization = props.localization;
      var dataDetail = props.dataDetail;
      var model = get('store.items', props);

      return (
        <div className="u_flexHorizontal">
          <div className="u_textTruncate">
            <TextHighLight
              highlight={model.searchText}
              text={dataDetail.name}
              className="text-bold"
              notHighlight={
                dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
              }
            />
          </div>
          <div className="u_fullInlineBlock">
            {this.showEditReportName() && (
              <a onClick={this.handleRename}>
                <span className="icon-pencil-new" title={localization.getText('COMMON_TOOLTIP_RENAME')} />
              </a>
            )}
          </div>
        </div>
      );
    },

    /** User can edit report name follow priority as below:
     *    System Admin (global & local reports)
     *    Local report
     *      Tenant has full report dashboard access
     *      Tenant is creator || owner of this report
     */
    showEditReportName: function() {
      var props = this.props;
      var currentUser = UiState.currentUser;
      var reportDesignerModel = get('fieldStore.masterModel', props);

      if (currentUser.systemAdmin) {
        return true;
      }

      if (!get('boardDetail.isGlobal', props) && !isNil(UiState.tenantId)) {
        return (
          reportDesignerModel.accessPriority === ACCESS_RIGHT.FullAccess ||
          reportDesignerModel.createdById === currentUser.id ||
          reportDesignerModel.ownerId === currentUser.id
        );
      }

      return false;
    },

    /**
     * Render component
     * @return {Object} component
     */
    render: function() {
      var dataDetail = this.props.dataDetail;

      return <div>{this.state.editMode ? this.renderEditReportName() : this.renderViewReportName()}</div>;
    }
  });

  module.exports = connect()(ReportName);
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportList/Izenda.ReportName.jsx